import { PromptSuggestion } from './types'

type ChatAssistantPromptSuggestionsProps = {
    suggestions: ReadonlyArray<PromptSuggestion>
    onSelect: (prompt: string) => void
}

export default function ChatAssistantPromptSuggestions({
    suggestions,
    onSelect
}: ChatAssistantPromptSuggestionsProps) {
    if (suggestions.length === 0) {
        return null
    }

    return (
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {suggestions.map((suggestion) => (
                <button
                    key={suggestion.id}
                    type="button"
                    onClick={() => onSelect(suggestion.prompt)}
                    className="group flex flex-col gap-2 rounded-2xl border border-gray-200 bg-white p-5 text-left shadow-sm transition-all hover:border-primary-300 hover:shadow-md"
                >
                    <span className="text-sm font-semibold text-gray-900 group-hover:text-primary-600">
                        {suggestion.title}
                    </span>
                    <span className="text-sm leading-6 text-gray-500">{suggestion.description}</span>
                </button>
            ))}
        </div>
    )
}
